import { authProvider } from "@/authProvider";
import { AuditLogProvider } from "@refinedev/core";
import { RestDataProvider } from "../data-provider/provider";
import { API_URL } from "../data-provider";
export const RestAuditLogProvider: AuditLogProvider = {
    get: async () => {
    },
    create: async (params) => {
        RestDataProvider(API_URL).custom({
            url: "/audit-logs",
            method: "post",
            payload: params,
        });
    },
    update: async () => {
    },
}

export const logAudit = async (resource: string, id: string | string[] | undefined, method: string, payload?: any, previousData?: any, mutateAction?: string) => {
   // Determine the action based on the HTTP method
   const action = method === "post"
     ? "create"
     : method === "put" || method === "patch"
       ? "update"
       : method === "delete"
         ? "delete"
         : "read";

   // Create the audit log with previousData if available
   RestAuditLogProvider.create({
     resource: resource,
     action: mutateAction ?? action,
     author: (await authProvider.getIdentity?.()) as { [key: string]: any; name?: string } | undefined,
     meta: { ids: id ? Array.isArray(id) ? id : [id] : undefined },
     data: payload || null,
     previousData: previousData || null,
   });
}